/**
 * 项目内客户端action功能封装
 */
import * as bridge from '@space/bridge'
const isDev = process.env.NODE_ENV === 'development'

// 设置页面title
export function setTitle(title: string) {
  bridge.setTitleBar({
    center: {
      title: {
        name: title,
      },
    },
  })
}

// 获取host
// type:
//    ”php“：客户端php host。“https://c.jzsec.com/”
//    “java”：客户端java host。
//    ”web“：公共的web页面host。
export function getHost(type: string = 'web') {
  return new Promise((resolve, reject) => {
    bridge.getHost(type).then((res: any) => {
      if (res.errorCode === 0 && res.response) {
        resolve(decodeURIComponent(res.response.host))
      } else {
        reject('host没获取到!!!')
      }
    })
  })
}

// 打开web页面
// 打开web页面
export function openWeb(url: string, title: any, project?: string) {
  window.location.href = url
}
